import type { FC, SVGProps } from 'react'

import { cn } from '@/lib/utils'

/** The Localboost house, drawn on a 100 x 100 grid. Shared by the logo, the intro and the hero window. */
export const HOUSE_PATH = 'M50 5 L95 39 V95 H5 V39 Z'
export const CHECK_PATH = 'M28 63 L44 78 L73 48'

/** House outline as polygon percentages, used for clip-path masks. */
export const HOUSE_POLYGON: Array<[number, number]> = [
    [0, 0.36],
    [0.5, 0],
    [1, 0.36],
    [1, 1],
    [0, 1]
]

interface HouseMarkProps extends SVGProps<SVGSVGElement> {
    variant?: 'solid' | 'outline'
    houseClassName?: string
    checkClassName?: string
}

export const HouseMark: FC<HouseMarkProps> = ({
    variant = 'solid',
    className,
    houseClassName,
    checkClassName,
    ...rest
}) => {
    const solid = variant === 'solid'

    return (
        <svg
            viewBox='0 0 100 100'
            aria-hidden='true'
            focusable='false'
            className={cn('overflow-visible', className)}
            {...rest}
        >
            <path
                d={HOUSE_PATH}
                pathLength={1}
                strokeWidth={solid ? 8 : 6}
                strokeLinejoin='round'
                data-house=''
                className={cn(solid ? 'fill-signal stroke-signal' : 'fill-none stroke-current', houseClassName)}
            />

            <path
                d={CHECK_PATH}
                pathLength={1}
                fill='none'
                strokeWidth={solid ? 10 : 8}
                strokeLinecap='round'
                strokeLinejoin='round'
                data-check=''
                className={cn(solid ? 'stroke-paper' : 'stroke-current', checkClassName)}
            />
        </svg>
    )
}
